module.exports = __webpack_public_path__ + "static/media/folders.ee67b4c4.svg";